
import Vue from "vue";
import store from "@/store";
import { provinces, cities } from "@/utils/geography";
import { validationMixin } from "vuelidate";
import { required, minLength } from "vuelidate/lib/validators";

export default Vue.extend({
  name: "ProfilePersonalInfo",
  mixins: [validationMixin],
  data() {
    return {
      defaultAvatar: require("@/assets/img/default-user.png"),
    };
  },
  methods: {
    provinces,
    cities,
    updateProfile(): void {
      store.dispatch("panel/updateProfile");
    },
    uploadAvatar(e: any): void {
      const file = e.target.files[0];
      if (file) {
        const fileReader = new FileReader();

        // update avatar in state and place on image placeholder
        fileReader.onload = (event) => {
          store.dispatch("panel/updateAvatar", event?.target?.result);
        };
        fileReader.readAsDataURL(file);

        // send choosed file
        let formData = new FormData();
        formData.append("image", file);
        store.dispatch("panel/uploadAvatar", formData);
      }
    },
    removeAvatar(): void {
      store.dispatch("panel/removeAvatar");
    },
  },
  computed: {
    // fullname
    fullname: {
      get(): string {
        return store.state.panel.user?.fullname || "";
      },
      set(value: string): void {
        store.dispatch("panel/updateFullName", value);
      },
    },
    fullnameError(): string[] {
      const errors: string[] = [];
      if (!this.$v.fullname?.$dirty) {
        return errors;
      }
      !this.$v.fullname.required && errors.push("تکمیل این فیلد الزامی است");
      return errors;
    },
    // address
    address: {
      get(): string {
        return store.state.panel.user?.address || "";
      },
      set(value: string): void {
        store.dispatch("panel/updateAddress", value);
      },
    },
    addressError(): string[] {
      const errors: string[] = [];
      if (!this.$v.address?.$dirty) {
        return errors;
      }
      !this.$v.address.minLength &&
        errors.push("آدرس باید دارای حداقل 10 حرف باشد");
      return errors;
    },
    // province
    province: {
      get(): string {
        return store.state.panel.user?.province || "";
      },
      set(value: string): void {
        store.dispatch("panel/updateProvince", value);
      },
    },
    // city
    city: {
      get(): string {
        return store.state.panel.user?.city || "";
      },
      set(value: string): void {
        store.dispatch("panel/updateCity", value);
      },
    },
    // loading status
    isLoading(): boolean {
      return store.state.app.loading;
    },
  },
  validations: {
    fullname: {
      required,
    },
    address: {
      minLength: minLength(10),
    },
    province: {
      required,
    },
    city: {
      required,
    },
  },
});
